module.exports = __webpack_public_path__ + "img/zx6.d4fc1a62.png";